// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"main": 0
};

__webpack_require__.f.j = (chunkId, promises) => {
		// JSONP chunk loading for javascript
		var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
		if(installedChunkData !== 0) { // 0 means "already installed".

			// a Promise means "currently loading".
			if(installedChunkData) {
				promises.push(installedChunkData[2]);
			} else {
				if(/^(default\-(libs_(survey\-elements_(grid\-((multip|sing)le\-choice|mixed)_settings_src_index_ts|((((|drop\-down\-)multiple\-ch|v)oic|imag)e|click\-to\-rank|numeric|open\-ended|video)_settings_src_index_ts)|hyper\-base_hyper\-base\-ng_src_index_ts)|node_modules_(angular_(c(dk_fesm2022_(_((a11|overla)y\-module\-chunk_mjs|array\-chunk_mjs\-node_modules_angular_cdk_fesm2022_\-224e1d)|(collections|dialog|drag\-drop|portal|scrolling|text\-field)_mjs)|o(mmon_fesm2022_(common|http)_mjs|re_fesm2022__(resource|untracked)\-chunk_mjs))|material_fesm2022_(_(animation\-chunk_mjs\-node_modules_angular_mate\-f65f44|error\-options\-chunk_mjs\-node_modules_angular_\-12ab76|pseudo\-checkbox\-module\-chunk_mjs\-node_modules\-bf71d0|ripple\-chunk_mjs\-node_modules_angular_materia\-ad4604)|c(ard|heckbox|ore)_mjs|((butt|expansi|ic)on|dialog|form\-field|list|menu|radio|select|slide\-toggle|tooltip)_mjs)|((platform\-browser_fesm2022_platform\-brows|router_fesm2022_rout)er|forms_fesm2022_forms)_mjs)|ng(rx_(data_fesm2022_ngrx\-data|effects_fesm2022_ngrx\-effects|store_fesm2022_ngrx\-store)_mjs|x\-(formly_(material_fesm2022_ngx\-formly\-material\-(form\-field|select)_mjs|core_fesm2022_ngx\-formly\-core_mjs)|(permissions_fesm2022_ngx\-permissions|toastr_fesm2022_ngx\-toastr)_mjs))|(lucide\-angular_fesm2020_lucide|sentry_angular_fesm2020_sentry)\-angular_mjs|rxjs_dist_esm_internal_operators_auditTime_js\-node_modules_rxjs_dist_esm\-9f2bd5))|libs_survey\-elements_s(kip\-logic_|urvey\-elements\-core_survey\-elements\-)core_src_index_ts|node_modules_(angular_(c(dk_fesm2022_(_(array\-chunk_mjs\-node_modules_angular_cdk_fesm2022__css\-pix\-e68fae[01]|breakpoints\-observer\-chunk_mjs\-_5dc7[01]|id\-generator\-chunk_mjs\-node_modules_angular_cdk_fesm2022__\-8ecfd3[01]|passive\-listeners\-chunk_mjs\-node_modules_angular_cdk_fesm2\-bf011d[01])|bidi_mjs\-_04d9[01]|observers_mjs\-_b1b1[01]|private_mjs\-_688b[01]|keycodes_mjs)|ore_fesm2022_(_not_found\-chunk|core)_mjs)|material_fesm2022_(_animation\-chunk_mjs\-_bdb8[01]|divider_mjs\-_593e[01]))|rxjs_dist_esm_(|operators_)index_js|(supabase_supabase\-js_dist_index|tslib_tslib_es6)_mjs)|apps_domains_infersurveys_src_bootstrap_ts|common|main|vendor)$/.test(chunkId)) {
					// setup Promise in chunk cache
					var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
					promises.push(installedChunkData[2] = promise);

					// start chunk loading
					var url = __webpack_require__.p + __webpack_require__.u(chunkId);
					// create error before stack unwound to get useful stacktrace later
					var error = new Error();
					var loadingEnded = (event) => {
						if(__webpack_require__.o(installedChunks, chunkId)) {
							installedChunkData = installedChunks[chunkId];
							if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
							if(installedChunkData) {
								var errorType = event && (event.type === 'load' ? 'missing' : event.type);
								var realSrc = event && event.target && event.target.src;
								error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
								error.name = 'ChunkLoadError';
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							}
						}
					};
					__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
				} else installedChunks[chunkId] = 0;
			}
		}
};

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunkinfersurveys"] = self["webpackChunkinfersurveys"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));